<template>
    <div class="ix-formbuilder-component-summary-content form-input-chart">
        
        <div class="formbuilder-component boxed padding" v-if="displayMode == 'readable' || displayMode == 'fillable'">
            <div class="mb-small">
                <p class="formbuilder-component-label">{{ currentField.label }}</p>
                <p class="formbuilder-component-help" v-if="currentField.helper">{{ currentField.helper}}</p>
            </div>

                <span v-if="loading && displayMode == 'readable'"><i class="far fa-circle-notch fa-spin"></i> Récupération des données en cours</span>
                <custom-chart :type="chartType" :datasets="currentField.collections.datasets" :labels="currentField.collections.labels" :options="options" v-if="displayMode == 'readable' && !loading"></custom-chart>
                <table class="formbuilder-table mt-3">
                <thead>
                    <tr>
                        <th></th>
                        <th class="text-center" v-for="(label,index) in currentField.collections.labels" :key="index">{{ label }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(element,index) in currentField.collections.datasets" :key="index">
                        <th :style="{'background' : element.backgroundColor}">{{ element.label }}</th>
                            <td v-for="(value,i) in  currentField.collections.labels" :key="i">
                            <input type="number" class="form-control" v-model="currentField.collections.datasets[index].data[i]" value="0" v-show="displayMode == 'fillable'">
                            <span v-if="displayMode == 'readable'">{{currentField.collections.datasets[index].data[i] }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-if="displayMode == 'summary'" class="ix-formbuilder-component-summary-info">
            <div class="ix-formbuilder-component-summary-handle">
                <span class="ix-drag-icon handle-line"></span>
            </div>
            <div class="ix-formbuilder-component-summary-icon" data-toggle="tooltip" data-placement="top" title="Graphique">
                <div class="ix-formbuilder-icon">
                    <i class="far fa-chart-area"></i>
                </div>
            </div>
            <div class="ix-formbuilder-component-summary-content">
                <span class="ix-formbuilder-component-summary-label">{{ currentField.label }}</span>
                <span class="ix-formbuilder-component-summary-help" v-if="currentField.helper">{{ currentField.helper }}</span>
                <ul class="ix-formbuilder-component-summary-options">
                    <li>Type de graphique : 
                        <span v-if="currentField.chartType == 'Line'">Courbe</span>
                        <span v-if="currentField.chartType == 'Bar'">Diagramme à barres</span>
                        <span v-if="currentField.chartType == 'Pie'">Diagramme circulaire</span>
                    </li>
                    <li>{{ currentField.collections.datasets.length }} série{{ currentField.collections.datasets.length > 1 ? 's' : '' }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

    import CustomChart from '../CustomChart.vue';

    export default {
        name: "ChartComponent",
        components: {CustomChart},
        props: ['currentField','displayMode', 'showIcon'],
        data(){
            return {
                options : {
                    responsive : true,
                    maintainAspectRatio: false,
                    showLines: true,
                },
                chartType : 'Line',
                componentKey: Math.random().toString(36).substr(2, 9),
                loading : true,
            }
        },
        created() {
          
            if(this.currentField.chartType){
                this.chartType = this.currentField.chartType.toLowerCase();
                this.loading = false;
            }



        },
        mounted() {
        },

    }
</script>

<style scoped>
    .chartjs-render-monitor {
        width: 1000px !important;
    }

</style>
